//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class LoginResponse {
    token : string;

    constructor() 
    {
    	            this.token = "" ;
        }
}

export class OnOfficePagedResponseOfOnOfficePagedEstateRow {
    page : number;
    total : number;
    data : OnOfficePagedEstateRow[];

    constructor() 
    {
    	            this.page = null ;
                this.total = null ;
                this.data = [];
        }
}

export class OnOfficePagedEstateRow {
    id : string;
    citta : string;
    isStammobjekt : number;
    numeroImmobile : string;
    indirizzo : string;
    numeroCivico : string;
    superficieCommerciale : string;
    createdOn : string;

    constructor() 
    {
    	            this.id = "" ;
                this.citta = "" ;
                this.isStammobjekt = null ;
                this.numeroImmobile = "" ;
                this.indirizzo = "" ;
                this.numeroCivico = "" ;
                this.superficieCommerciale = "" ;
                this.createdOn = "" ;
        }
}

export class SearchEstatePagedVm {
    page : number;
    count : number;
    citta : string;
    numeroImmobile : string;
    stammobjektOnly : boolean;
    indirizzo : string;
    zona : string;
    createdFrom : string ;
    createdTo : string ;
    superficieCommercialeMin : number;
    superficieCommercialeMax : number;

    constructor() 
    {
    	            this.page = null ;
                this.count = null ;
                this.citta = "" ;
                this.numeroImmobile = "" ;
                this.stammobjektOnly = false ;
                this.indirizzo = "" ;
                this.zona = "" ;
                this.createdFrom = null;
                this.createdTo = null;
                this.superficieCommercialeMin = null ;
                this.superficieCommercialeMax = null ;
        }
}

export class GetEstateValuesVm {
    printProjectIdentifier : string;
    estateId : string;

    constructor() 
    {
    	            this.printProjectIdentifier = "" ;
                this.estateId = "" ;
        }
}

export class GetEstateFilesResponse {
    type : string;
    position : number;
    documentAttribute : string;
    name : string;
    originalname : string;
    filename : string;
    fileSize : number;
    title : string;
    freetext : string;
    modified : number;
    category : string;
    content : string;
    imageUrl : string;

    constructor() 
    {
    	            this.type = "" ;
                this.position = null ;
                this.documentAttribute = "" ;
                this.name = "" ;
                this.originalname = "" ;
                this.filename = "" ;
                this.fileSize = null ;
                this.title = "" ;
                this.freetext = "" ;
                this.modified = null ;
                this.category = "" ;
                this.content = "" ;
                this.imageUrl = "" ;
        }
}

export class TablePagedResultOfOnOfficeFieldDefinition {
    data : OnOfficeFieldDefinition[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class BaseEntity {
    identifier : string;
    createdOn : string ;
    modifiedOn : string ;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.modifiedOn = null;
        }
}

export class OnOfficeFieldDefinition extends BaseEntity {
    label : string;
    fieldName : string;
    fieldType : string;

    constructor() 
    {
    	        super();
		            this.label = "" ;
                this.fieldName = "" ;
                this.fieldType = "" ;
        }
}

export class BaseListFilterVm {
    pageNumber : number;
    perPage : number;
    sortBy : SortByParameter;

    constructor() 
    {
    	            this.pageNumber = null ;
                this.perPage = null ;
                this.sortBy = new SortByParameter();
        }
}

export class OnOfficeFieldDefinitionListFilterVm extends BaseListFilterVm {
    search : string;

    constructor() 
    {
    	        super();
		            this.search = "" ;
        }
}

export class SortByParameter {
    propertyName : string;
    ascending : boolean;

    constructor() 
    {
    	            this.propertyName = "" ;
                this.ascending = false ;
        }
}

export class TablePagedResultOfPrintedPdf {
    data : PrintedPdf[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class PrintedPdf extends BaseEntity {
    userActivationIdentifier : string;
    printProject : NameIdentifier;
    attachment : Attachment;

    constructor() 
    {
    	        super();
		            this.userActivationIdentifier = "" ;
                this.printProject = new NameIdentifier();
                this.attachment = new Attachment();
        }
}

export class NameIdentifier {
    name : string;
    identifier : string;

    constructor() 
    {
    	            this.name = "" ;
                this.identifier = "" ;
        }
}

export class Attachment {
    identifier : string;
    filename : string;
    path : string;
    mimeType : string;
    publicUrl : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.filename = "" ;
                this.path = "" ;
                this.mimeType = "" ;
                this.publicUrl = "" ;
        }
}

export class PrintedPdfListFilterVm extends BaseListFilterVm {
    createdOnFrom : string ;
    createdOnTo : string ;
    printProjectIdentifier : string;

    constructor() 
    {
    	        super();
		            this.createdOnFrom = null;
                this.createdOnTo = null;
                this.printProjectIdentifier = "" ;
        }
}

export class TablePagedResultOfPrintProject {
    data : PrintProject[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class PrintProject extends BaseEntity {
    name : string;
    webUserId : string;
    userActivationIdentifier : string;
    template : NameIdentifier;
    templateSnapshot : TemplateSettings;
    estateSelections : EstateSelection[];
    slotImages : SlotImage[];

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.webUserId = "" ;
                this.userActivationIdentifier = "" ;
                this.template = new NameIdentifier();
                this.templateSnapshot = new TemplateSettings();
                this.estateSelections = [];
                this.slotImages = [];
        }
}

export class TemplateSettings {
    format : PageFormat;
    pages : TemplatePage[];
    maxEstates : number;
    boundFields : string[];

    constructor() 
    {
    	            this.format = new PageFormat();
                this.pages = [];
                this.maxEstates = null ;
                this.boundFields = [];
        }
}

export class PageFormat {
    widthMm : number;
    heightMm : number;

    constructor() 
    {
    	            this.widthMm = null ;
                this.heightMm = null ;
        }
}

export class TemplatePage {
    fabricJson : string;

    constructor() 
    {
    	            this.fabricJson = "" ;
        }
}

export class EstateSelection {
    estate : number;
    estateId : string;
    description : string;

    constructor() 
    {
    	            this.estate = null ;
                this.estateId = "" ;
                this.description = "" ;
        }
}

export class SlotImage {
    slot : string;
    estateId : string;
    imageUrl : string;

    constructor() 
    {
    	            this.slot = "" ;
                this.estateId = "" ;
                this.imageUrl = "" ;
        }
}

export class PrintProjectListFilterVm extends BaseListFilterVm {
    createdOnFrom : string ;
    createdOnTo : string ;
    webUserId : string;
    name : string;

    constructor() 
    {
    	        super();
		            this.createdOnFrom = null;
                this.createdOnTo = null;
                this.webUserId = "" ;
                this.name = "" ;
        }
}

export class TablePagedResultOfPrintTemplate {
    data : PrintTemplate[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class PrintTemplate extends BaseEntity {
    name : string;
    title : string;
    description : string;
    isActive : boolean;
    settings : TemplateSettings;
    thumbnail : Attachment;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.title = "" ;
                this.description = "" ;
                this.isActive = false ;
                this.settings = new TemplateSettings();
                this.thumbnail = new Attachment();
        }
}

export class PrintTemplateListFilterVm extends BaseListFilterVm {
    createdOnFrom : string ;
    createdOnTo : string ;
    name : string;
    title : string;
    isActive : boolean;

    constructor() 
    {
    	        super();
		            this.createdOnFrom = null;
                this.createdOnTo = null;
                this.name = "" ;
                this.title = "" ;
                this.isActive = false ;
        }
}

export class TablePagedResultOfUserActivation {
    data : UserActivation[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class UserActivation extends BaseEntity {
    name : string;
    webUserId : string;
    marketplaceData : MarketplaceData;
    apiUserData : ApiUserData;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.webUserId = "" ;
                this.marketplaceData = new MarketplaceData();
                this.apiUserData = new ApiUserData();
        }
}

export class MarketplaceData {
    userSecret : string;
    apiToken : string;
    apiClaim : string;

    constructor() 
    {
    	            this.userSecret = "" ;
                this.apiToken = "" ;
                this.apiClaim = "" ;
        }
}

export class ApiUserData {
    useApiUser : boolean;
    apiSecret : string;
    apiToken : string;

    constructor() 
    {
    	            this.useApiUser = false ;
                this.apiSecret = "" ;
                this.apiToken = "" ;
        }
}

export class UserActivationListFilterVm extends BaseListFilterVm {
    createdOnFrom : string ;
    createdOnTo : string ;
    name : string;
    webUserId : string;

    constructor() 
    {
    	        super();
		            this.createdOnFrom = null;
                this.createdOnTo = null;
                this.name = "" ;
                this.webUserId = "" ;
        }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}